<template>
    <div class="c-land-detail-middle">
        <div class="c-land-detail-middle__header">
            <i class="el-icon-arrow-left arrow-back" @click="goBack"></i>
            {{ landName }}
            <span v-if="contentType === 'photo'" style="padding-left: 20px">{{
                formatDate(currentAtlas.actEndTime, 'YYYY-MM-DD')
            }}</span>
        </div>
        <BgWrap class="c-land-detail-middle__content">
            <template v-if="contentType === 'atlas'">
                <PictureContent
                    :showPagination="false"
                    :showPreButton="false"
                    cardType="atlas"
                    :data="atlas"
                    bottomShowType="always"
                    @pic-card-click="handleAtlasClick"
                >
                    <template v-slot:bottom="scope">
                        <div style="line-height: 1.3">
                            <div style="text-align: center">
                                {{ scope.data.actEndTime }}
                            </div>
                        </div>
                    </template>
                    <template v-slot:default="scope">
                        <div class="pic-center">{{ formatDate(scope.data.actEndTime, 'YYYY-MM-DD') }}</div>
                    </template>
                </PictureContent>
            </template>
            <template v-else-if="contentType === 'photo'">
                <PictureContent
                    :showPagination="false"
                    :showPreButton="false"
                    cardType="picture"
                    :data="picList"
                    bottomShowType="always"
                    @pic-card-click="() => {}"
                >
                    <template v-slot:bottom="scope">
                        <div style="line-height: 1.3">
                            <div style="text-align: center">
                                {{ scope.data.uploadDate }}
                            </div>
                        </div>
                    </template>
                    <template v-slot:default="scope">
                        <div class="pic-center">{{ formatDate(scope.data.uploadDate, 'YYYY-MM-DD') }}</div>
                    </template>
                </PictureContent>
            </template>
        </BgWrap>
    </div>
</template>

<script>
import moment from 'moment';
import PictureContent from '../../../components/PictureContent.vue';
import BgWrap from '../../../layout/components/BgWrap.vue';
import { fetchLandAtlas } from '../../Api';

export default {
    components: {
        PictureContent,
        BgWrap,
    },
    props: {
        landName: {
            // 地块名称
            type: String,
            default: '',
        },
        landId: {
            // 地块id
            type: String,
            default: '',
        },
    },
    data() {
        return {
            atlas: [], // 图集
            currentAtlas: {}, // 当前浏览图集
            picList: [], // 图片列表
            contentType: 'atlas', // 当前页面的内容是图册模式还是图片模式 atlas:图册模式,photo:图片模式
        };
    },
    methods: {
        goBack() {
            if (this.contentType === 'photo') {
                this.contentType = 'atlas';
            } else {
                this.$router.go(-1);
            }
        },
        /**
         * 点击图集
         */
        handleAtlasClick(data) {
            this.currentAtlas = data;
            let picList = data.pictureList || [];
            picList.forEach((item) => {
                let fullPath = item.fullPath;
                item.url = fullPath;
            });
            this.picList = picList;
            this.contentType = 'photo';
        },
        /**
         *获取图集
         */
        getLandAtlas() {
            let landId = this.landId;
            let list = [];
            if (landId) {
                fetchLandAtlas(landId)
                    .run()
                    .then((res) => {
                        list = res || [];
                        list.forEach((item) => {
                            let pictureList = item.pictureList || [];
                            let url = '';
                            // 设置第一张图为图册预览图
                            if (pictureList.length > 0) {
                                url = pictureList[0].fullPath;
                            }

                            item.url = url;
                        });
                        this.atlas = list;
                    });
            }
        },
        formatDate(val, format = 'YYYY-MM-DD') {
            let text = '';
            if (val) {
                text = moment(val).format(format);
            }
            return text;
        },
    },
    mounted() {
        this.getLandAtlas();
    },
    watch: {
        landId() {
            this.contentType = 'atlas';
            this.getLandAtlas();
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@Theme/config.scss';
@import '~@Theme/mixins/index.scss';
$header-height: 40px;
$bg-1: #071150;
@include b(land-detail-middle, c) {
    height: 100%;
    width: 100%;
    position: relative;
    @include e(header) {
        height: $header-height;
        display: flex;
        box-sizing: border-box;
        align-items: center;
        .arrow-back {
            cursor: pointer;
            font-size: 20px;
        }
    }
    @include e(content) {
        padding: 4px;
        height: calc(100% - #{$header-height} - 4px - 4px);
        background: $bg-1;
    }
    ::v-deep .pic-center {
        position: absolute;
        top: 35%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: rgba(7, 17, 80, 0.8);
        padding: 8px;
        font-size: 20px;
    }
}
</style>
